module.exports = __webpack_public_path__ + "img/login1.a7861738.png";